import Box from '@mui/material/Box';
import ErrorIcon from '@mui/icons-material/Error';
import Grid from '@mui/material/Unstable_Grid2';
import Paper from '@mui/material/Paper';
import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

const StyledPaper = styled(Paper)({
  background: '#FBDCDC',
  padding: '8px'
});

interface ErrorPanelProps {
  title: string;
  message?: string;
  details?: string;
}

const ErrorPanel = (props: ErrorPanelProps) => (
  <Box m={2}>
    <StyledPaper>
      <Grid container wrap="nowrap" spacing={2}>
        <Grid xs={1}>
          <ErrorIcon color="error" />
        </Grid>
        <Grid>
          <Typography variant="body1" component="span">
            {props.title}
          </Typography>
          <Typography variant="body2">{props.message}</Typography>
          <Typography variant="caption">{props.details}</Typography>
        </Grid>
      </Grid>
    </StyledPaper>
  </Box>
);

export default ErrorPanel;
